import Box from '@mui/material/Box';
import { useMemo } from 'react';
import { SidebarGroup } from '@backstage/core-components';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { IconComponent } from '@backstage/core-plugin-api';
import { NavDeveloperAssistantIcon } from '../icons/NavDeveloperAssistantIcon';
import { useDeveloperPortalSupportAgentPermissions } from '../../hooks/useDeveloperPortalSupportAgentPermissions';

const ICON_SIZE = 20;

export const DeveloperAssistantSidebarItem = () => {
  const { canRead, loading } = useDeveloperPortalSupportAgentPermissions();

  const SmallIcon: IconComponent = useMemo(
    () => props =>
      (
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            '& svg': {
              width: ICON_SIZE,
              height: ICON_SIZE,
              fontSize: ICON_SIZE,
            },
          }}
        >
          <NavDeveloperAssistantIcon {...props} />
        </Box>
      ),
    [],
  );

  if (loading || !canRead) return null;

  return (
    <SidebarGroup
      label="Developer Assistant"
      icon={<SmallIcon />}
      to="/developer-assistant"
    >
      <SidebarItem
        icon={SmallIcon}
        to="/developer-assistant"
        text="Developer Assistant"
      />
    </SidebarGroup>
  );
};
